module.exports = __webpack_public_path__ + "static/media/concept-energy-label-app.88123e6f.svg";